<div class="settings-bloc">
    <div class="settings-bloc-toggle">
        <div class="settings-bloc-toggle__header">
            <div class="container-label">
                <span class="heading-xs">Intro</span>
                <span class="body-m">Optional step to provide context or guidance before users select product types.</span>
            </div>
            <app-slide-toggle
                [checked]="adminService.settings()['settings.intro.toggle']"
                (checkedChange)="onSettingToggle('settings.intro.toggle', $event)">
            </app-slide-toggle>
        </div>
    </div>
    <div class="settings-bloc-toggle">
        <div class="settings-bloc-toggle__header">
            <div class="container-label">
                <span class="heading-xs">Fragrance profile</span>
                <span class="body-m">Turn on the note guide to help clients who are less familiar with fragrance notes.</span>
            </div>
            <app-chip type="neutral" text="Mandatory" size="large">
            </app-chip>
        </div>
        <div class="settings-bloc-toggle__content">
            <app-slide-toggle
                [checked]="adminService.settings()['settings.notes.wizard.toggle']"
                (checkedChange)="onSettingToggle('settings.notes.wizard.toggle', $event)">
            </app-slide-toggle>
            <span class="body-m">Note suggestion option</span>
        </div>
    </div>
</div>  